function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, HTMLAttributes, useMemo } from 'react';
import cn from 'classnames';
import { Icon } from '../../Icon';
import { IconNameSmall } from '../../Icon/icons';
import { Link } from '../../Link';
import { Tooltip } from '../../Tooltip';
import { Typography } from '../../Typography';
require("./ProductInformer.css");
var styles = {
  "Root": "ProductInformer-module-Root_3b9",
  "Link": "ProductInformer-module-Link_bo9",
  "Text": "ProductInformer-module-Text_1Cb",
  "Icon": "ProductInformer-module-Icon_1gr"
};
export const ProductInformer = ({
  className,
  tooltip,
  iconName,
  iconColor,
  children,
  color = '#576875',
  link,
  ...rest
}) => {
  const iconStyles = useMemo(() => iconColor ? {
    fill: iconColor
  } : {}, [iconColor]);
  const textStyles = useMemo(() => ({
    color
  }), [color]);
  const icon = iconName || (tooltip ? 'info' : '');
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cn(styles.Root, className)
  }, rest), tooltip && /*#__PURE__*/React.createElement(Tooltip, {
    className: styles.tooltip,
    placement: "top-start",
    content: tooltip,
    offset: -3,
    hasArrow: true
  }, /*#__PURE__*/React.createElement(Icon, {
    size: "s",
    className: styles.Icon,
    name: icon,
    style: iconStyles
  })), !tooltip && icon && /*#__PURE__*/React.createElement(Icon, {
    size: "s",
    className: styles.Icon,
    name: icon,
    style: iconStyles
  }), link ? /*#__PURE__*/React.createElement(Link, {
    className: styles.Link,
    href: link,
    style: textStyles
  }, children) : /*#__PURE__*/React.createElement(Typography, {
    className: styles.Text,
    variant: "p2",
    style: textStyles
  }, children));
};